/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/bestellung-entry-dtp-zusatzdaten.ts.
 */
import {User} from './user';
import {DtpZusatzdatentyp} from './dtp-zusatzdatentyp';
import {BestellungEntryDtpZusatzdatenError} from './bestellung-entry-dtp-zusatzdaten-error';

/**
 * Zweck: Beschreibt class BestellungEntryDtpZusatzdaten und ihren Daten- oder Funktionsvertrag.
 */
export class BestellungEntryDtpZusatzdaten {
  id: number;
  matchcode: string;
  data: any;
  file: any;
  zusatzdaten: DtpZusatzdatentyp;
  tsUpdated: string;
  updatedBy: User;
  defect: boolean;
  validationError: string;
  errors: BestellungEntryDtpZusatzdatenError[];
  lastError: BestellungEntryDtpZusatzdatenError;
  dsgvoManualBlackening: boolean;
  dsgvoAutoBlackening: boolean;
}
